






















































































import { mapState } from 'vuex'

import CardHeader from "@/components/CardHeader.vue";
import { BasicMixin } from "@/mixins/AdminMixin"

import { Component, Mixins } from 'vue-property-decorator'
import {ActivityCategoryInterface} from "@/models/Activity";
@Component({
    components:{
        CardHeader
    },
   computed:{
       ...mapState({
           ActivityCategory:(state: any) => state.activity.ActivityCategory
       })
   }
})
export default class ActivityCategory extends Mixins(BasicMixin) {

    public headers = [
        {
            text: 'Actividad',
            align: 'left',
            sortable: true,
            value: 'title',
        },
        {
            text: 'Creado',
            align: 'left',
            sortable: true,
            value: 'createdAt',
        },
        { text: 'Opciones', value: 'actions' },
    ];

    public actCategory: ActivityCategoryInterface = {
        title: '',
    };


    formSubmit(){
        if (this.edit){
            this.$store.dispatch('editCollect', {id: this.idModel, data: this.actCategory, collection: 'ActivityCategory'});
            this.text = 'Se ha editado la categoria';
            this.dialog = false;
            this.snackbar = true;
        } else {
            this.$store.dispatch('createCategory', this.actCategory);
            this.text = 'Se ha creado la categoria';
            this.dialog = false;
            this.snackbar = true;
        }

    }

    openModal(edit: boolean, item: ActivityCategoryInterface | any) {
        this.edit = edit;
        this.dialog = true;
        this.idModel = item.id;
        if (edit) {
            this.actCategory = {
               title: item.title
            }
        } else {
            this.actCategory = {
                title: ''
            }
        }
    }
    deleteItem(item: any){
        this.$store.dispatch('deleteCollect', {id:item.id, collection:'ActivityCategory'})
    }
}
